import { styled } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'
import { colors } from 'constants/theme'

export const RowFilter = styled(Box)(({ theme }) => ({
  '.MuiAutocomplete-root': {
    '.MuiInputBase-formControl': {
      paddingTop: '2.5px !important',
      paddingRight: '28px !important',
      '.MuiOutlinedInput-input': {
        lineHeight: 2
      },
      '.MuiAutocomplete-clearIndicator': {
        right: 7
      }
    }
  },
  '.btn-export': {
    button: {
      marginLeft: 'auto'
    },
    '&.disabled': {
      button: {
        border: `1px solid ${colors.disabledGray} !important`,
        color: `${colors.disabledGray} !important`
      }
    }
  }
}))

export const AutoCompleteFilter = styled(Box)<{ type: 'branch' | 'patient' | 'operativeType' | 'operative' }>(({ theme, type }) => ({
  '.title': {
    position: 'absolute',
    top: '50%',
    left: 16,
    transform: 'translateY(-50%)',
    zIndex: 1
  },
  '.MuiAutocomplete-root': {
    '.MuiInputBase-formControl': {
      paddingLeft: `${(type === 'branch' && '81px') || (type === 'patient' && '95px') || (type === 'operativeType' && '127px') || '74px'} !important`
    }
  }
}))

export const ResponsiveTable = styled(Box)(({ theme }) => ({
  '.MuiTable-root': {
    '.MuiTableBody-root': {
      '.MuiTableCell-root': {
        verticalAlign: 'top !important',
        paddingBottom: '16px',
        '&.action': {
          paddingTop: '13px'
        }
      }
    }
  }
}))

export const Title = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  color: colors.themeMainColor,
  fontSize: 16
}))
export const SubTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: 14
}))


export const Body = styled('div')(({ theme }) => ({
  margin: '1rem 0 .5rem',
  [theme.breakpoints.down('sm')]: {
    marginBottom: 0
  }
}))

export const RowTextField = styled('div')(({ theme }) => ({
  display: 'flex',
  marginBottom: '1rem',
  '.MuiFormHelperText-root.Mui-error': {
    span: {
      whiteSpace: 'nowrap'
    }
  },
  [theme.breakpoints.up('sm')]: {
    '& .MuiFormControl-root:first-of-type': {
      marginRight: '0.5rem'
    },
    '& .MuiFormControl-root:last-of-type': {
      marginLeft: '0.5rem'
    }
  },
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    '& .MuiFormControl-root:last-of-type': {
      marginTop: '1rem'
    }
  }
}))
